"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var CalculatorContextInterface_1 = require("../CalculatorContextInterface");
var CalculatorServerView = function () {
    var _a = (0, CalculatorContextInterface_1.useCalculatorContext)(), game = _a.game, server = _a.server, sale = _a.sale, setServer = _a.setServer, appOrder = _a.appOrder, serverList = _a.serverList, setServerList = _a.setServerList, setServerDefaultList = _a.setServerDefaultList;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var _c = (0, react_hook_form_1.useFormContext)(), register = _c.register, errors = _c.formState.errors, setValue = _c.setValue;
    //const [serverList, setServerList] = useState<Server[]>([]);
    (0, react_1.useEffect)(function () {
        if (game && game.id) {
            axios_1.default.get("/app/game/".concat(game.id, "/server"))
                .then(function (response) {
                if (response.status == 200) {
                    setServerList(response.data);
                    setServerDefaultList(response.data);
                }
                if (sale) {
                    setValue('server_id', sale.server_id);
                    setServer(serverList === null || serverList === void 0 ? void 0 : serverList.find(function (value) { return value.id == sale.id; }));
                }
            }).catch(function (error) {
                //console.log("error", error);
            });
        }
    }, [game]);
    function handleServerChange(e) {
        var item = serverList === null || serverList === void 0 ? void 0 : serverList.find(function (x) { return x.id === parseInt(e.target.value); });
        setServer(item);
    }
    (0, react_1.useEffect)(function () {
        if (sale) {
            setValue('server_id', sale.server_id);
            //console.log('server id', serverList.find(value => value.id == sale.server_id));
            setServer(serverList === null || serverList === void 0 ? void 0 : serverList.find(function (value) { return value.id == sale.server_id; }));
        }
        else {
            if ((serverList === null || serverList === void 0 ? void 0 : serverList.length) === 1) {
                setValue('server_id', serverList[0].id);
                setServer(serverList[0]);
            }
        }
    }, [sale, serverList]);
    (0, react_1.useEffect)(function () {
        if (appOrder && serverList) {
            setValue('server_id', appOrder.order_type_id);
            setServer(serverList.find(function (value) { return value.id == appOrder.order_type_id; }));
        }
    }, [appOrder, serverList]);
    return (react_1.default.createElement("div", { className: "__wrap-item" },
        react_1.default.createElement("div", { className: "__wrap-top-item" }, errors.server_id
            ?
                react_1.default.createElement("div", { className: "__has-error" }, t("calculator.server.error.emty"))
            :
                react_1.default.createElement("span", { className: "__top-notification" }, t("calculator.server.select.caption"))),
        react_1.default.createElement("select", __assign({ className: (0, classnames_1.default)(errors.server_id ? "__error" : "", server ? "__succeess" : ""), style: { width: "100%" } }, register('server_id', {
            valueAsNumber: true,
            required: true,
            validate: {
                positive: function (v) { return parseInt(v) > 0; },
            },
            onChange: function (e) { return handleServerChange(e); }
        }), { disabled: sale ? true : false, value: sale === null || sale === void 0 ? void 0 : sale.server_id, defaultValue: 0 }),
            react_1.default.createElement("option", { disabled: true, hidden: true, value: 0 }, t("calculator.server.select.select")),
            serverList && serverList.map(function (item) {
                return react_1.default.createElement("option", { 
                    //selected={sale?.server_id == item.id}
                    key: item.id, value: item.id }, item.app_locale_name);
            }))));
};
exports.default = CalculatorServerView;
